import { render, staticRenderFns } from "./ProjectBasicInfo.vue?vue&type=template&id=aea35242"
import script from "./ProjectBasicInfo.vue?vue&type=script&lang=js"
export * from "./ProjectBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports